import { render, staticRenderFns } from "./integrationsListSkeleton.vue?vue&type=template&id=03e25c96&scoped=true&"
import script from "./integrationsListSkeleton.vue?vue&type=script&lang=js&"
export * from "./integrationsListSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./integrationsListSkeleton.vue?vue&type=style&index=0&id=03e25c96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e25c96",
  null
  
)

export default component.exports